module.exports = __webpack_public_path__ + "static/media/CircularStd-MediumItalic.dcb304fd.otf";